import React from 'react'
// import MpesaTopUp from './MpesaTopup'
import BankTopup from './BankTopup'

const Topups = () => {
  return (
    <div className="mx-auto p-4">
      <h4><b>Top Up Your Account</b></h4>

      {/* tabs */}
      <div role="tablist" className="tabs tabs-bordered mt-2">
        {/* <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Mpesa Top up" defaultChecked />
        <div role="tabpanel" className="tab-content py-4 overflow-hidden">
          <MpesaTopUp />
        </div> */}

        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Bank Top up" defaultChecked />
        <div role="tabpanel" className="tab-content py-4">
          <BankTopup />
        </div>
      </div>
    </div>
  )
}

export default Topups
